import styled, { css } from 'styled-components'

const designerCSS = css`
  display: flex;
  flex-direction: column;
`

export const RightPanel = styled.div`
  ${designerCSS}
`
